export const COLOR_PALETTE = [
  '#1f6feb',
  '#2da44e',
  '#bf8700',
  '#cf222e',
  '#8250df',
  '#e16f24',
  '#0e8a8a',
  '#6e7781',
];

export const NEUTRAL_COLOR = '#6e7781';
